//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';

export default {
    name: 'BowFilters',

    props: {
        htmlTag: {
            default: null,
            type: String,
        },
        onSubmit: {
            default: () => {},
            type: Function,
        },
    },

    data: () => ({
        ospitiList: [],
    }),

    fetch() {
        this.ospitiList = [
            {
                label: this.$t('Non specificato'),
                value: 0,
            },
            {
                label: `1 ${this.$t('ospite')}`,
                value: 1,
            },
        ];

        for (let i = 2; i < 21; i += 1) {
            this.ospitiList.push({
                label: `${i} ${this.$t('ospiti')}`,
                value: i,
            });
        }
    },

    computed: {
        ...mapState({
            activeFilters: ({ filters }) => filters.activeFilters,
            filters: ({ filters }) => filters.filters,
            isFiltersOpen: ({ ui }) => ui.isFiltersOpen,
        }),
        ...mapGetters([
            'filters/GET_ACTIVE_FILTERS',
            'filters/GET_FILTERS',
            'ui/GET_IS_FILTERS_OPEN',
        ]),
    },

    destroyed() {
        this.$store.dispatch('ui/UPDATE_IS_FILTERS_OPEN', false);
        this.$store.dispatch('filters/RESET_FILTERS');
        document.querySelector('body').classList.remove('overflow-y-hidden');
    },

    methods: {
        ...mapActions([
            'filters/UPDATE_ACTIVE_FILTERS',
            'filters/UPDATE_FILTERS',
            'filters/RESET_FILTERS',
            'ui/UPDATE_IS_FILTERS_OPEN',
        ]),

        checkActiveFilters(fd) {
            let counter = 0;
            // console.log(fd);

            if (
                fd.tipologia.ville === true ||
                fd.tipologia.appartamenti === true ||
                fd.tipologia.case === true
            ) {
                counter += 1;
                // console.log(counter);
            }

            if (fd.ospiti && fd.ospiti !== 0 && fd.ospiti !== '0') {
                counter += 1;
                // console.log(counter);
            }

            Object.entries(fd.servizi).forEach(([key, value]) => {
                if (value === true) {
                    counter += 1;
                    // console.log(counter);
                }
            });

            this.$store.dispatch('filters/UPDATE_ACTIVE_FILTERS', counter);
        },

        handleSubmit(e) {
            const formData = {
                tipologia: {
                    ville: document.querySelector('[name="ville"]').checked,
                    appartamenti: document.querySelector(
                        '[name="appartamenti"]'
                    ).checked,
                    case: document.querySelector(
                        '[name="case"]'
                    ).checked,
                },
                ospiti: document.querySelector('[name="ospiti"]').value,
                servizi: {
                    parcheggio: document.querySelector('[name="parcheggio"]')
                        .checked,
                    piscina: document.querySelector('[name="piscina"]').checked,
                    giardino:
                        document.querySelector('[name="giardino"]').checked,
                    spiaggia: document.querySelector(
                        '[name="spiaggia-privata"]'
                    ).checked,
                    animali: document.querySelector('[name="animali"]').checked,
                },
            };

            this.checkActiveFilters(formData);

            this.$store.dispatch('filters/UPDATE_FILTERS', {
                ...formData,
            });

            this.onSubmit(this.filters);

            this.$store.dispatch('ui/UPDATE_IS_FILTERS_OPEN', false);

            document
                .querySelector('body')
                .classList.remove('overflow-y-hidden');
        },
    },
};
